"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOnMarketByPropertyType$ = exports.TimeOnMarketByPropertyType$outboundSchema = exports.TimeOnMarketByPropertyType$inboundSchema = void 0;
exports.timeOnMarketByPropertyTypeToJSON = timeOnMarketByPropertyTypeToJSON;
exports.timeOnMarketByPropertyTypeFromJSON = timeOnMarketByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statspropertytype_js_1 = require("./statspropertytype.js");
/** @internal */
exports.TimeOnMarketByPropertyType$inboundSchema = z.object({
    average_days_on_market: z.number().int(),
    property_type: statspropertytype_js_1.StatsPropertyType$inboundSchema,
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_days_on_market": "averageDaysOnMarket",
        "property_type": "propertyType",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.TimeOnMarketByPropertyType$outboundSchema = z.object({
    averageDaysOnMarket: z.number().int(),
    propertyType: statspropertytype_js_1.StatsPropertyType$outboundSchema,
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageDaysOnMarket: "average_days_on_market",
        propertyType: "property_type",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TimeOnMarketByPropertyType$;
(function (TimeOnMarketByPropertyType$) {
    /** @deprecated use `TimeOnMarketByPropertyType$inboundSchema` instead. */
    TimeOnMarketByPropertyType$.inboundSchema = exports.TimeOnMarketByPropertyType$inboundSchema;
    /** @deprecated use `TimeOnMarketByPropertyType$outboundSchema` instead. */
    TimeOnMarketByPropertyType$.outboundSchema = exports.TimeOnMarketByPropertyType$outboundSchema;
})(TimeOnMarketByPropertyType$ || (exports.TimeOnMarketByPropertyType$ = TimeOnMarketByPropertyType$ = {}));
function timeOnMarketByPropertyTypeToJSON(timeOnMarketByPropertyType) {
    return JSON.stringify(exports.TimeOnMarketByPropertyType$outboundSchema.parse(timeOnMarketByPropertyType));
}
function timeOnMarketByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TimeOnMarketByPropertyType$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TimeOnMarketByPropertyType' from JSON`);
}
//# sourceMappingURL=timeonmarketbypropertytype.js.map